import React from 'react';

const useCases = {
    intro: {
        title: 'Use Cases',
        subTitle: 'Real Problems. Real Deployments.',
    },
    subIntro: {
        leftAligned: true,
        children: (
            <>
                <p>We solve the hard problems — formulating your business challenge mathematically and finding the best approach. Here's where our platforms are already working.</p>
            </>
        ),
    },
    divider: {},
    subIntro1: {
        children: (
            <>
                <h2>Telecommunications</h2>
            </>
        ),
    },
    cardsGroup: {
        children: [
            {
                icon: 'icon-radio',
                title: 'TAC/Paging Optimization',
                card: "Mobile networks waste bandwidth on paging signals when TAC boundaries are wrong. FENNEQ predicts subscriber movement from CDRs, then optimizes boundaries. Result: major reduction in paging load for regional operators.",
            },
            {
                icon: 'icon-broadcast',
                title: 'Frequency Planning',
                card: "Assigning frequencies to minimize interference is a graph coloring problem that explodes combinatorially. FENNEQ handles real-world constraints — regulations, equipment, existing assignments — and finds better solutions faster.",
            },
        ],
    },
    divider1: {},
    subIntro2: {
        children: (
            <>
                <h2>Aviation</h2>
            </>
        ),
    },
    cardsGroup1: {
        children: [
            {
                icon: 'icon-send',
                title: 'Stand Allocation',
                card: "Aircraft to gates, real-time, with all the constraints — size, airline, connections, equipment. Deployed at major regional airport. FENNEQ re-optimizes dynamically as flights delay or cancel.",
            },
            {
                icon: 'icon-truck',
                title: 'Ground Resources',
                card: "Crews, baggage, fuel, catering, cleaning — all need to hit the aircraft within tight turnaround windows. FENNEQ schedules the whole operation, minimizing delays and resource waste.",
            },
        ],
    },
    divider2: {},
    subIntro3: {
        children: (
            <>
                <h2>Energy</h2>
            </>
        ),
    },
    cardsGroup2: {
        children: [
            {
                icon: 'icon-atom',
                title: 'Nuclear Fuel Loading',
                card: "Research collaboration: Where you place fuel rods affects power distribution, burnup, and safety. FENNEQ delivers faster optimization cycles, better utilization, same safety margins.",
            },
            {
                icon: 'icon-power',
                title: 'Grid Balancing',
                card: "Pilot program with regional utilities: Balancing supply and demand with variable renewables. FENNEQ handles unit commitment, storage, and demand response together.",
            },
        ],
    },
    divider3: {},
    subIntro4: {
        children: (
            <>
                <h2>Post-Quantum Security (QASER)</h2>
                <p>Different platform, same philosophy — sovereign technology for critical infrastructure.</p>
            </>
        ),
    },
    cardsGroup3: {
        children: [
            {
                icon: 'icon-shield-check',
                title: 'Government Communications',
                card: "Sovereign encryption that can't be compromised by foreign adversaries or future quantum computers. Homegrown ML-KEM/ML-DSA. Full source access for security review.",
            },
            {
                icon: 'icon-wallet',
                title: 'Financial Services',
                card: "Transactions must stay confidential for decades. Current encryption won't survive quantum. QASER: inventory, migration roadmap, proxy for legacy systems, native integration for new builds.",
            },
            {
                icon: 'icon-lock',
                title: 'Critical Infrastructure',
                card: "SCADA and industrial control systems can't be easily updated. QASER wraps them in quantum-safe tunnels without touching the code. Air-gapped options available.",
            },
        ],
    },
    divider4: {},
    quote: {
        children: (
            <>
                Have a problem that might fit? Let's talk.
            </>
        ),
        cta: {
            url: '/contact',
            children: 'Contact Us',
        },
    },
};

export default useCases;
